export const game_1 = [
  {
    letter: "A",
    letterImg: "SUB A/A.webp",
    objectImg: "SUB A/Apple.webp",
    // objectImg: "SUB A/GIF/apple_new.gif",
    nameImg: "SUB A/Apple-text.webp",
    music: "PHONIC SOUND/ALPHABET 1/A_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Apple.mp3",
    name: "Apple",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
  {
    letter: "M",
    letterImg: "SUB A/M.webp",
    objectImg: "SUB A/Monkey.webp",
    // objectImg: "SUB A/GIF/monkey.gif",
    music: "PHONIC SOUND/ALPHABET 1/M_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Monkey_01.mp3",
    nameImg: "SUB A/Monkey-text.webp",
    name: "Monkey",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 6
  },
  {
    letter: "T",
    letterImg: "SUB A/T.webp",
    objectImg: "SUB A/Train-800.webp",
    // objectImg: "SUB A/GIF/train.gif",
    music: "PHONIC SOUND/ALPHABET 1/T_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Train_01.mp3",
    nameImg: "SUB A/Train-text.webp",
    name: "Train",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
]
export const game_2 = [
  {
    letter: "S",
    letterImg: "SUB A/S.webp",
    objectImg: "SUB A/Sun.webp",
    // objectImg: "SUB A/GIF/sun.gif",
    music: "PHONIC SOUND/ALPHABET 1/S_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Sun_01.mp3",
    nameImg: "SUB A/Sun-text.webp",
    name: "Sun",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 3
  },
  {
    letter: "I",
    letterImg: "SUB A/I.webp",
    objectImg: "SUB A/Ink-800.webp",
    // objectImg: "SUB A/GIF/ink.gif",
    music: "PHONIC SOUND/ALPHABET 1/I_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Ink_02.mp3",
    nameImg: "SUB A/Ink-text.webp",
    name: "Ink",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 3
  },
  {
    letter: "F",
    letterImg: "SUB A/F.webp",
    objectImg: "SUB A/Fish.webp",
    // objectImg: "SUB A/GIF/fish.gif",
    music: "PHONIC SOUND/ALPHABET 1/F_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Fish_01.mp3",
    nameImg: "SUB A/Fish-text.webp",
    name: "Fish",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
]
export const game_3 = [
  {
    letter: "D",
    letterImg: "SUB A/D.webp",
    objectImg: "SUB A/Dog.webp",
    // objectImg: "SUB A/GIF/dog.gif",
    music: "PHONIC SOUND/ALPHABET 1/D_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Dog_01.mp3",
    nameImg: "SUB A/Dog-text.webp",
    name: "Dog",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 3
  },
  {
    letter: "R",
    letterImg: "SUB A/R.webp",
    objectImg: "SUB A/Rabbit.webp",
    // objectImg: "SUB A/GIF/rabbit.gif",
    music: "PHONIC SOUND/ALPHABET 1/R_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Rabbit_01.mp3",
    nameImg: "SUB A/Rabbit-text.webp",
    name: "Rabbit",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 6
  },
  {
    letter: "O",
    letterImg: "SUB A/O.webp",
    objectImg: "SUB A/Octopus.webp",
    // objectImg: "SUB A/GIF/Octopus.gif",
    music: "PHONIC SOUND/ALPHABET 1/O_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Octopus_01.mp3",
    nameImg: "SUB A/Octopus-text.webp",
    name: "Octopus",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 7
  },

];
export const game_4 = [
  {
    letter: "G",
    letterImg: "SUB B/G.webp",
    objectImg: "SUB B/Goat.webp",
    // objectImg: "SUB B/GIF/goat.gif",
    music: "PHONIC SOUND/ALPHABET 1/G_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Goat_01.mp3",
    nameImg: "SUB B/Goat-text.webp",
    name: "Goat",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
  {
    letter: "L",
    letterImg: "SUB B/L.webp",
    objectImg: "SUB B/Lion.webp",
    // objectImg: "SUB B/GIF/lion.gif",
    music: "PHONIC SOUND/ALPHABET 1/L_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Lion_01.mp3",
    nameImg: "SUB B/Lion-text.webp",
    name: "Lion",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
  {
    letter: "H",
    letterImg: "SUB B/H.webp",
    objectImg: "SUB B/Horse.webp",
    // objectImg: "SUB B/GIF/horse.gif",
    music: "PHONIC SOUND/ALPHABET 1/H_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Horse_01.mp3",
    nameImg: "SUB B/Horse-text.webp",
    name: "Horse",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
]

export const game_5 = [
  {
    letter: "U",
    letterImg: "SUB B/U.webp",
    objectImg: "SUB B/Umbrella.webp",
    // objectImg: "SUB B/GIF/umbrella.gif",
    music: "PHONIC SOUND/ALPHABET 1/U_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Umbrella_01.mp3",
    nameImg: "SUB B/Umbrella-text.webp",
    name: "Umbrella",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 8
  },
  {
    letter: "C",
    letterImg: "SUB B/C.webp",
    objectImg: "SUB B/Cat.webp",
    // objectImg: "SUB B/GIF/cat.gif",
    music: "PHONIC SOUND/ALPHABET 1/C_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Cat_01.mp3",
    nameImg: "SUB B/Cat-text.webp",
    name: "Cat",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 3
  },
  {
    letter: "B",
    letterImg: "SUB B/B.webp",
    objectImg: "SUB B/Ball.webp",
    // objectImg: "SUB B/GIF/ball.gif",
    music: "PHONIC SOUND/ALPHABET 1/B_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Ball_01.mp3",
    nameImg: "SUB B/Ball-text.webp",
    name: "Ball",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
]

export const game_6 = [
  {
    letter: "N",
    letterImg: "SUB B/N.webp",
    objectImg: "SUB B/Nest.webp",
    // objectImg: "SUB B/GIF/nest.gif",
    music: "PHONIC SOUND/ALPHABET 1/N_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Nest_01.mp3",
    nameImg: "SUB B/Nest-text.webp",
    name: "Nest",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
  {
    letter: "K",
    letterImg: "SUB B/K.webp",
    objectImg: "SUB B/Kite.webp",
    // objectImg: "SUB B/GIF/kite.gif",
    music: "PHONIC SOUND/ALPHABET 1/K_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Kite_02.mp3",
    nameImg: "SUB B/Kite-text.webp",
    name: "Kite",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
  {
    letter: "V",
    letterImg: "SUB B/V.webp",
    objectImg: "SUB B/Van.webp",
    // objectImg: "SUB B/GIF/van.gif",
    music: "PHONIC SOUND/ALPHABET 1/V_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Van_01.mp3",
    nameImg: "SUB B/Van-text.webp",
    name: "Van",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 3
  },
];

export const game_7 = [
  {
    letter: "E",
    letterImg: "SUB C/E.webp",
    objectImg: "SUB C/Egg.webp",
    music: "PHONIC SOUND/ALPHABET 1/E_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Egg_01.mp3",
    nameImg: "SUB C/Egg-text.webp",
    name: "Egg",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 3
  },
  {
    letter: "W",
    letterImg: "SUB C/W.webp",
    objectImg: "SUB C/Watermelon.webp",
    // objectImg: "SUB C/GIF/watermelon.gif",
    music: "PHONIC SOUND/ALPHABET 1/W_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Watermelon_01.mp3",
    nameImg: "SUB C/Watermelon-text-2.webp",
    name: "Watermelon",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 10
  },
  {
    letter: "J",
    letterImg: "SUB C/J.webp",
    objectImg: "SUB C/Juice.webp",
    music: "PHONIC SOUND/ALPHABET 1/J_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Juice_01.mp3",
    nameImg: "SUB C/Juice-text.webp",
    name: "Juice",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
]

export const game_8 = [
  {
    letter: "P",
    letterImg: "SUB C/P.webp",
    objectImg: "SUB C/Pencil.webp",
    // objectImg: "SUB C/GIF/pencil.gif",
    music: "PHONIC SOUND/ALPHABET 1/P_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Pencil_01.mp3",
    nameImg: "SUB C/Pencil-text.webp",
    name: "Pencil",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 6
  },
  {
    letter: "Y",
    letterImg: "SUB C/Y-3.webp",
    objectImg: "SUB C/Yellow.webp",
    // objectImg: "SUB C/GIF/yellow.gif",
    music: "PHONIC SOUND/ALPHABET 1/Y_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Yellow_01.mp3",
    nameImg: "SUB C/Yellow-text-2.webp",
    name: "Yellow",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 6
  },
  {
    letter: "X",
    letterImg: "SUB C/X.webp",
    objectImg: "SUB C/X ray.webp",
    // objectImg: "SUB C/GIF/x-ray.gif",
    music: "PHONIC SOUND/ALPHABET 1/X_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/X-Ray_01.mp3",
    nameImg: "SUB C/X-ray-text.webp",
    name: "X-ray",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
]

export const game_9 = [
  {
    letter: "Q",
    letterImg: "SUB C/Q.webp",
    objectImg: "SUB C/Queen.webp",
    // objectImg: "SUB C/GIF/queen.gif",
    music: "PHONIC SOUND/ALPHABET 1/Q_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Queen_01.mp3",
    nameImg: "SUB C/Queen-text.webp",
    name: "Queen",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
  {
    letter: "Z",
    letterImg: "SUB C/Z.webp",
    objectImg: "SUB C/zebra.webp",
    // objectImg: "SUB C/GIF/zibra.gif",
    music: "PHONIC SOUND/ALPHABET 1/Z_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Zebra_01.mp3",
    nameImg: "SUB C/Zebra-Text.webp",
    name: "Zebra",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
  {
    letter: "X",
    letterImg: "SUB C/X.webp",
    objectImg: "SUB C/X ray.webp",
    // objectImg: "SUB C/GIF/x-ray.gif",
    music: "PHONIC SOUND/ALPHABET 1/X_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/X-Ray_01.mp3",
    nameImg: "SUB C/X-ray-text.webp",
    name: "X-ray",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
];

export const game_10 = [
  {
    letter: "Ch",
    letterImg: "SUB 02/01/CH-1.webp",
    objectImg: "SUB 02/01/chocolate.webp",
    // objectImg: "SUB 02/01/GIF/chocolate.gif",
    music: "PHONIC SOUND/DIGRAPH/Ch.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Chocolate_01.mp3",
    nameImg: "SUB 02/01/Chocolate-text.webp",
    name: "Chocolate",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 9
  },
  {
    letter: "Sh",
    letterImg: "SUB 02/01/Sh.webp",
    objectImg: "SUB 02/01/Shoe.webp",
    // objectImg: "SUB 02/01/GIF/shoe.gif",
    music: "PHONIC SOUND/DIGRAPH/Sh_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Shoe_01.mp3",
    nameImg: "SUB 02/01/Shoe-text.webp",
    name: "Shoe",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
  {
    letter: "Th",
    letterImg: "SUB 02/01/Th.webp",
    objectImg: "SUB 02/01/Three.webp",
    // objectImg: "SUB 02/01/GIF/three.gif",
    music: "PHONIC SOUND/DIGRAPH/Th_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Three_01.mp3",
    nameImg: "SUB 02/01/Three-text.webp",
    name: "Three",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
];

export const game_11 = [
  {
    letter: "Sp",
    letterImg: "SUB 02/02/Sp-2.webp",
    objectImg: "SUB 02/02/Spoon.webp",
    // objectImg: "SUB 02/02/GIF/spoon.gif",
    music: "PHONIC SOUND/BLENDS/Sp.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Spoon_01.mp3",
    nameImg: "SUB 02/02/Spoon-text.webp",
    name: "Spoon",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
  {
    letter: "Sn",
    letterImg: "SUB 02/02/sn.webp",
    objectImg: "SUB 02/02/Snake.webp",
    // objectImg: "SUB 02/02/GIF/snake.gif",
    music: "PHONIC SOUND/BLENDS/Sn_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Snake_01.mp3",
    nameImg: "SUB 02/02/Snake-text.webp",
    name: "Snake",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
  {
    letter: "Bl",
    letterImg: "SUB 02/02/Bl.webp",
    objectImg: "SUB 02/02/Blocks.webp",
    // objectImg: "SUB 02/02/GIF/block.gif",
    music: "PHONIC SOUND/BLENDS/Bl_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Block_01.mp3",
    nameImg: "SUB 02/02/Block-text.webp",
    name: "Block",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 6
  },
];

export const game_12 = [
  {
    letter: "Dr",
    letterImg: "SUB 02/03/Dr.webp",
    objectImg: "SUB 02/03/Drum.webp",
    // objectImg: "SUB 02/03/GIF/drum.gif",
    music: "PHONIC SOUND/BLENDS/Dr_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Drum_01.mp3",
    nameImg: "SUB 02/03/Drum-letter.webp",
    name: "Drum",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 4
  },
  {
    letter: "Cl",
    letterImg: "SUB 02/03/Cl.webp",
    objectImg: "SUB 02/03/Clock.webp",
    // objectImg: "SUB 02/03/GIF/clock.gif",
    music: "PHONIC SOUND/BLENDS/Cl_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Clock_01.mp3",
    nameImg: "SUB 02/03/Clock-text.webp",
    name: "Clock",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
  {
    letter: "Tr",
    letterImg: "SUB 02/03/Tr.webp",
    objectImg: "SUB A/Train-800.webp",
    // objectImg: "SUB A/GIF/train.gif",
    music: "PHONIC SOUND/BLENDS/Tr_01.mp3",
    wordMusic: "PHONIC SOUND/WORDS/Train_01.mp3",
    nameImg: "SUB A/Train-text.webp",
    name: "Train",
    yay: "PHONIC SOUND/YAY/Yay.mp3",
    y: "PHONIC SOUND/YAY/Y.mp3",
    wordCount: 5
  },
];
